<template>
 
   <el-select v-model="value" clearable v-on:change="selectChange" :placeholder="placeholder">
    <el-option
      v-for="item in items"
      :key="item.code"
      :label="item.value"
      :value="item.code">
    </el-option>
  </el-select>
</template>

<script>
import { getDictionary } from "@/api/src/emergency_common";
export default {
  name: "ZJComponent-Dropdown",
  props: {
    syscode: {
      required: false,
      default: ""
    },
    ukey: {
      required: true,
      default: ""
    },
    path: String,
    placeholder:{
      type:String,
      default:"全部"
    }
  },
  data() {
    return {
      items: [],
      value:''
    };
  },
  mounted() {
    this.draw();
  },
  methods: {
    draw: function() {
      getDictionary(this.ukey)
        .then(d => {
          this.items = d.data.records;
        })
        .catch(e => console.error(e));
    },
    selectChange:function(selectValue){
      selectValue = selectValue == '' ? null : selectValue
      this.$emit("onSelectChange",selectValue);
    }
  }
};
</script>